import React from 'react';
import SearchRequestProvider from './SearchRequestProvider';
import FiltersProviders from '@components/Filters/Filters/FiltersProviders';
import FilteredItinerariesProvider from './FilteredItinerariesProvider';
import SearchResponseProvider from './SearchResponseProvider';
import SearchTrackerProvider from './SearchTrackerProvider';
import { SortedItinerariesProvider } from '@components/Sorting/Provider';
import ParsedSearchResponseProvider from './ParsedSearchResponseProvider';
import ItinerariesPricesProvider from './ItinerariesPricesProvider';
import DisplayedItinerariesProvider from './DisplayedItinerariesProvider';
import FeeTypeProvider from './FeeTypeProvider';
import ItineraryTripUIProvider from './ItineraryTripProvider';
import ItinerarySelectionProvider from './ItinerarySelectionProvider';
import { ResultsPageTrackingProvider } from './TrackingProviders';
import FlexibleDatesProvider from './FlexibleDatesProvider';
import FlexibleDatesRoundTripProvider from './FlexibleDatesRoundTripProvider';
import AccommodationRecommendationsProvider from './AccommodationRecommendationsProvider';
import { ShoppingBundleProvider } from 'clientState/providers/ShoppingBundleProvider';
import PrimeTooltipStateProvider from './PrimeTooltipStateProvider';
import FavoritesListProvider from './FavoritesListProvider';
import FavoriteLayerProvider from './FavoriteLayerProvider';
import AlternativeItineraryMutationProvider from './AlternativeItineraryMutationProvider';
import TrackingDecorationProvider from 'clientState/providers/TrackingDecorationProvider';
import { SelectedUnbundleDepartureProvider } from './SelectedUnbundleDepartureProvider';
import { ValidationErrorModalProvider } from './ValidationErrorModalProvider/ValidationErrorModalProvider';

const noop = Function.prototype;
const asyncNoop = () => Promise.reject();

export default function FlightsResultsProviders({
  listenSearchRequestChanges,
  stopListenSearchRequestChanges,
  onSearchLoaded = noop,
  onCreateMapiShoppingCart = asyncNoop,
  onSearchMapiError = () => {},
  onFeeTypeChange = noop,
  onDisplayedItinerariesChange = noop,
  endSearchMetric = () => {},
  onNoSearchResults = () => {},
  onLoadingResultsPage = () => {},
  onSearchParamsError = () => {},
  itinerarySelectionActions,
  itineraryFromUrl,
  children,
}) {
  return (
    <ResultsPageTrackingProvider>
      <TrackingDecorationProvider>
        <SearchTrackerProvider endSearchMetric={endSearchMetric}>
          <SearchRequestProvider
            listenSearchRequestChanges={listenSearchRequestChanges}
            stopListenSearchRequestChanges={stopListenSearchRequestChanges}
          >
            <FlexibleDatesProvider>
              <FlexibleDatesRoundTripProvider>
                <FeeTypeProvider onChange={onFeeTypeChange}>
                  <AlternativeItineraryMutationProvider>
                    <ValidationErrorModalProvider>
                      <SelectedUnbundleDepartureProvider>
                        <SearchResponseProvider
                          onNoSearchResults={onNoSearchResults}
                          onCreateMapiShoppingCart={onCreateMapiShoppingCart}
                          onSearchMapiError={onSearchMapiError}
                          onLoadingResultsPage={onLoadingResultsPage}
                          onSearchParamsError={onSearchParamsError}
                        >
                          <AccommodationRecommendationsProvider>
                            <ParsedSearchResponseProvider
                              onSearchLoaded={onSearchLoaded}
                            >
                              <FiltersProviders>
                                <ItinerariesPricesProvider>
                                  <SortedItinerariesProvider>
                                    <FilteredItinerariesProvider>
                                      <DisplayedItinerariesProvider
                                        onDisplayedItinerariesChange={
                                          onDisplayedItinerariesChange
                                        }
                                      >
                                        <FavoritesListProvider>
                                          <FavoriteLayerProvider>
                                            <ItineraryTripUIProvider>
                                              <ShoppingBundleProvider
                                                actions={
                                                  itinerarySelectionActions
                                                }
                                              >
                                                <ItinerarySelectionProvider
                                                  itineraryFromUrl={
                                                    itineraryFromUrl
                                                  }
                                                >
                                                  <PrimeTooltipStateProvider>
                                                    {children}
                                                  </PrimeTooltipStateProvider>
                                                </ItinerarySelectionProvider>
                                              </ShoppingBundleProvider>
                                            </ItineraryTripUIProvider>
                                          </FavoriteLayerProvider>
                                        </FavoritesListProvider>
                                      </DisplayedItinerariesProvider>
                                    </FilteredItinerariesProvider>
                                  </SortedItinerariesProvider>
                                </ItinerariesPricesProvider>
                              </FiltersProviders>
                            </ParsedSearchResponseProvider>
                          </AccommodationRecommendationsProvider>
                        </SearchResponseProvider>
                      </SelectedUnbundleDepartureProvider>
                    </ValidationErrorModalProvider>
                  </AlternativeItineraryMutationProvider>
                </FeeTypeProvider>
              </FlexibleDatesRoundTripProvider>
            </FlexibleDatesProvider>
          </SearchRequestProvider>
        </SearchTrackerProvider>
      </TrackingDecorationProvider>
    </ResultsPageTrackingProvider>
  );
}
